export default "__VITE_ASSET__02347807__"